import { Progress } from 'antd';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { faNumber } from 'utils/common.util';
import { StyledLink } from './style';

const Card: React.FC<{
  href: string;
  isRegistered: boolean;
  buttonTitle: string;
  data: {
    thumbnail: string;
    image: string;
    title: string;
    type: string;
    status: string;
    id: number;
    progress: number;
  };
}> = ({ data, buttonTitle, isRegistered, href }) => {
  return (
    <Link href={href || ''}>
      <StyledLink className="bg-black10 bg-term-bg shrink-0 text-black70 hover:text-black70 flex p-[6px] rounded-xl cursor-pointer">
        <div className="relative shrink-0 size-[96px] md:size-[128px]">
          <Image
            className="bg-blue-2 rounded-xl "
            src={data?.thumbnail || data.image}
            width={128}
            height={128}
            alt=""
          />
        </div>

        <div className="flex flex-col w-full justify-between p-[8px] pt-[12px]">
          <div className="text-[13px] md-text-[16px] font-regular">{data.title}</div>
          {data.progress && (
            <div className="toRight">
              <div className="-mb-[8px]">{faNumber(data.progress)}%</div>
              <Progress
                percent={data.progress}
                trailColor="#CBD5E1"
                strokeColor={
                  data.progress < 20
                    ? '#991B1B'
                    : data.progress < 100
                    ? '#F59E0B'
                    : '#3C9090'
                }
                showInfo={false}
              />
            </div>
          )}
          <button
            type="button"
            className={`${
              isRegistered ? 'bg-berry70' : 'bg-green70'
            } self-end flex items-center gap-[4px] justify-center rounded-md text-black10 text-[11px] md:text-[12px] w-[96px] h-[25px] md:h-[32px]`}
          >
            <i className="icon-teacher text-[14px]" />
            {buttonTitle}{' '}
          </button>
        </div>
      </StyledLink>
    </Link>
  );
};

export default Card;
